import { Button, Grid } from "@mui/material";
import _ from "lodash";
import { useState } from "react";
import TemplateCreator from "./creator";
import TemplatePicker from "./picker";
import { Tooltip } from "@mui/material";

const TemplatesMenu = (props) => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const toggleDialogOpen = () => setDialogOpen((open) => !open);
  const {
    addMedicine,
    form: { getValues },
    type,
    disabledAddMedicine,
    canCreate
  } = props;
  const medicines = getValues("medicines");
  const [openTootip, setOpenTootip] = useState(false);

  const handleAddApplication = addMedicine;

  const handleClick = () => {
    if (medicines.some((medicine) => medicine.text === "")) {
      setOpenTootip(true);
    } else {
      handleAddApplication();
    }
  };

  const handleCloseTootip = () => {
    setOpenTootip(false);
  };

  return (
    <>
      <Grid container alignItems="center">
        <Grid item xs={12} sm={7.6}>
          <TemplatePicker {...props} />
        </Grid>

        <Grid
          item
          xs={12}
          sm={4.4}
          sx={{
            display: "flex",
            justifyContent: "space-evenly",
            mt: { xs: 2, sm: 0 },
          }}
        >
          {canCreate && (
            <Button size="small" variant="customGreen" onClick={toggleDialogOpen}>
              Crear Plantilla
            </Button>
          )}
          <Tooltip
            open={openTootip}
            onClose={handleCloseTootip}
            arrow
            title={`Debes completar la ${type === "prescription" ? "prescripción" : "solicitud de prácticas"}`}
          >
            <Button
              size="small"
              variant="contained"
              disabled={disabledAddMedicine}
              onClick={handleClick}
            >
              Agregar {type === "prescription" ? "medicamento" : "solicitud"}
            </Button>
          </Tooltip>
        </Grid>
      </Grid>
      <TemplateCreator
        {...props}
        open={dialogOpen}
        toggleOpen={toggleDialogOpen}
      />
    </>
  );
};

export default TemplatesMenu;
